export default function AimTrainerIcon() {
  return (
    <svg viewBox="0 0 64 64" aria-hidden="true" fill="none" strokeLinecap="round">
      <rect x="2" y="2" width="60" height="60" rx="12" fill="#1b2440" />
      <circle cx="32" cy="32" r="17" fill="#0b6f9e" />
      <circle cx="32" cy="32" r="17" fill="url(#aimTrainerGrad)" />
      <circle cx="26" cy="26" r="5" fill="#d9fbff" opacity=".7" />
      <path d="M32 6v12M32 46v12M6 32h12M46 32h12" stroke="#7dff9a" strokeWidth="4" />
      <circle cx="32" cy="32" r="2.5" fill="#7dff9a" />
      <defs>
        <radialGradient id="aimTrainerGrad" cx=".35" cy=".35" r=".7">
          <stop offset="0" stopColor="#d9fbff" />
          <stop offset=".4" stopColor="#3fe0ff" />
          <stop offset="1" stopColor="#0b6f9e" />
        </radialGradient>
      </defs>
    </svg>
  );
}
